import { ModuleEnum } from "@/model/ModuleEnum";
import TaskModuleConfigurationTemperature from "./TaskModuleConfigurationTemperature";
import TaskModuleConfigurationAction from "./TaskModuleConfigurationAction";

export default abstract class TaskModuleConfiguration {
  public abstract clone(): any;

  public abstract toFirebase(): any;

  public static fromJson(moduleEnum: ModuleEnum, conf: any): TaskModuleConfiguration {
    return null;
  }
}
